import { Box, Button, Heading, Text, VStack } from "@chakra-ui/react";
import { useExternalServices } from "../../contexts/externalServicesContext";

const SignupWithStravaPage = () => {
  const { strava } = useExternalServices();

  return (
    <Box bg="secondary.900" p={8} borderRadius="lg" boxShadow="2xl" minW="400px">
      <VStack spacing={4} align="stretch">
        <Heading size="lg" color="cyan.300">
          Connect Strava
        </Heading>
        <Text color="primary.100">
          Connect your Strava account to enable sync, activity import, and downstream analysis
          flows.
        </Text>
        {strava.error ? <Text color="orange.300">{strava.error.message}</Text> : null}
        <Button colorScheme="orange" onClick={strava.startConnect}>
          Connect with Strava
        </Button>
      </VStack>
    </Box>
  );
};

export default SignupWithStravaPage;
